const indexFundsSymbols = [
    "FINNIFTY",
    "BANKNIFTY",
    "MIDCPNIFTY",
    "MIDCPNifty",
    "BANK NIFTY",
    "NIFTY",
    "NIFTY 50",
    "SENSEX",
    "CNX 500",
    "CNX IT",
    "NIFTY JR",
    "NIFTY 500",
    "NIFTY MIDCAP 100",
    "NIFTY 100",
    "NIFTY IT",
    "NIFTYMID50",
    "BANKEX",
    "BSE 100",
    "BSE 500",
    "BSE MIDCAP",
    "BSE 200",
    "BSE PSU",
    "BSE IPO",
    "BSE BANKEX",
    "BSE CAPITAL GOODS",
    "BSE OIL&GAS",
    "BSE METAL",
    "BSE CONSUMER DURABLE",
    "BSE AUTO",
    "BSE IT",
    "BSE FMCG",
    "BSE HEALTHCARE",
    "Nifty Mid100 Free",
    "Nifty Auto",
    "Nifty Metal",
    "NIFTY SMALLCAP 100",
    "NIFTY SMALLCAP 250",
    "NIFTY MIDCAP 50",
    "NIFTY SMALLCAP 50"
];
export { indexFundsSymbols };
